module.exports = __webpack_public_path__ + "static/images/containers/ClanPanel/components/BattlesButton/images/glow-top.da715f81.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanPanel/components/BattlesButton/images/glow-top.png
// module id = 3060
// module chunks = 11